import React from 'react'
import { Box, Typography, Container } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { TrustpilotReview } from '@talentinc/gatsby-source-trustpilot-widget'
import getColor from '../../utils/colors'
import useBrand from '../../hooks/useBrand'
import { BGVariants } from '../../types/heroTextSection'

interface ReviewProps {
  review: TrustpilotReview
  background: BGVariants
}

const ReviewCardSimple: React.FC<ReviewProps> = ({ review, background }) => {
  const { classes, cx } = useStyles({ background })
  const brand = useBrand()

  return (
    <Container
      itemScope
      itemType="https://schema.org/Review"
      className={cx(classes.containerReview, {
        [classes.containerReviewNarrow]:
          brand.name === 'TopResume' || brand.name === 'TopCV',
      })}
      disableGutters
    >
      <Box
        className={cx(classes.cardContentReview, {
          [classes.cardContentReviewCentered]:
            brand.name === 'TopResume' || brand.name === 'TopCV',
          [classes.cardContentReviewLessPadding]:
            brand.name === 'TopResume' || brand.name === 'TopCV',
        })}
      >
        <Box
          itemProp="reviewRating"
          itemScope
          itemType="https://schema.org/Rating"
        >
          <meta itemProp="worstRating" content="1" />
          <meta itemProp="ratingValue" content={review.stars.toString()} />
          <meta itemProp="bestRating" content="5" />
        </Box>
        <meta itemProp="datePublished" content={review.createdAt} />
        <Typography
          className={classes.text}
          variant={'body2'}
          itemProp="reviewBody"
        >
          {review.text}
        </Typography>
        <Typography
          className={cx(classes.title, {
            [classes.titleCentered]:
              brand.name === 'TopResume' || brand.name === 'TopCV',
            [classes.titleNormalWeight]:
              brand.name === 'TopResume' || brand.name === 'TopCV',
          })}
          variant={brand.name === 'TopResume' || 'TopCV' ? 'body1' : 'h4'}
          itemProp="author"
        >
          — {review.consumer.displayName}
        </Typography>
      </Box>
    </Container>
  )
}

const useStyles = makeStyles<{ background: string }>()(
  (theme, { background }) => {
    const bgColor = getColor(background, theme)

    return {
      containerReview: {
        backgroundColor: bgColor,
        display: 'flex',
        flexDirection: 'column',
        margin: '1.55rem auto',
        width: '90%',
      },
      containerReviewNarrow: {
        maxWidth: '39rem',
      },
      cardContentReview: {
        display: 'flex',
        textAlign: 'left',
        flexDirection: 'column',
        padding: '3rem',

        [theme.breakpoints.down('md')]: {
          padding: '1rem 0',
        },
      },
      cardContentReviewCentered: {
        textAlign: 'center',
      },
      cardContentReviewLessPadding: {
        paddingBottom: '.5rem',
      },
      title: {
        width: '100%',
        textAlign: 'right',
        fontWeight: 'bold',
        padding: '1.5625rem 0 .65rem 0',
      },
      titleCentered: {
        textAlign: 'center',
      },
      titleNormalWeight: {
        fontWeight: 400,
      },
      text: {
        [theme.breakpoints.down('md')]: {
          fontSize: '1rem',
        },
      },
    }
  }
)

export default ReviewCardSimple
